module.exports = __webpack_public_path__ + "static/c54687215c270285f9af98ab3d129bce7a61f9eb808bee55306a6fac9cfba468-982ea08c0c756d665ed5e62af3264e73.png";